// 文章
import Axios from '@/assets/js/ajax'

const state = {
  insightList: [], 
  
}

const getters = {
  insightList: state => state.insightList,
}

const mutations = {
  setInsightList (state, payload) {
      state.insightList = payload.data
  },
  
}

const actions = {
  async getInsightList ({commit}, ids) {
    let {data} = await Axios.post('/getLike', {
        data: ids
    })
    commit('setInsightList', {data: data.data})
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}